import React, {Component} from 'react';
import './App.less';
import {connect} from 'react-redux'
import './config/FJConfig';
import {FJCloudAction, FJMediaAction, FJModalAction} from "./redux/action/FJRoot.action";
import FJActionConstant from './constant/FJActionConstant';
import FJHeaderContainer from "./component/header/container/FJHeaderContainer";
import FJTimeLineContainer from "./component/timeLine/container/FJTimelineContainer";
import FJExportModalContainer from "./component/export/container/FJExportModalContainer";
import FJModalContainer from './component/modal/container/FJModalContainer';
import FJResourcesContainer from "./component/resources/container/FJResourcesContainer";
import FJPreviewContainer from "./component/preview/container/FJPreviewContainer";
import styles from './AppContent.module.less'
import FJUtil from "./util/FJUtil";
import key from 'keymaster'
import store from "./redux/reducer/FJRoot.reducer";
import FJPretreatmentStore from "./store/FJPretreatmentStore";
import FJMenuContainer from "./component/menu/container/FJMenuContainer";
import $ from "jquery";
import FJBrowserFilter from './common/component/FJBrowserFilter/FJBrowserFilter'
import FJCanvasStore from "./store/FJCanvasStore";
import FJCoreUtil from "./core/util/FJCoreUtil";
import FJEventConstant from "./constant/FJEventConstant";
import FJPaymentAction from "./redux/action/FJPayment.action";

class AppContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      height: 0,
    }
  }

  componentDidMount() {

    const {updateLimits, updateLevel, checkLevel, setIsShowQuickGuideModal, levelChangedCallback, updateAllDownloadData, dealCloudZone, showStorageFulled} = this.props;

    $('#btUser').show();
    this._adaptScreen();
    window.addEventListener('resize', () => {
      this._adaptScreen();
    });

    FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
    FJUtil.allTooltip('u-tooltip-left', 'left');
    FJUtil.allTooltip('u-tooltip-right', 'right');
    FJUtil.allTooltip('u-tooltip-top', 'top');

    key.setScope('default');

    window.FJEvent.subscribe('moveAndResizeChangeStart', () => {
      FJUtil.toggleScope('changeStart');
    });
    window.FJEvent.subscribe('moveAndResizeChangeEnd', () => {
      FJUtil.toggleScope('changeEnd');
    });
    window.FJEvent.subscribe(FJEventConstant.UPDATE_RESOURCE_DOWNLOAD_DATA, updateAllDownloadData)
    window.FJEvent.subscribe(FJEventConstant.INDEXEDDB_FULLED, showStorageFulled)

    FJPretreatmentStore.init(store);

    if (window.FJGlobalariable && window.FJGlobalariable.modSubscription
      && window.FJGlobalariable.modSubscription.addSubscriptionChangedListener) {
      window.FJGlobalariable.modSubscription.addSubscriptionChangedListener(levelChangedCallback)
    }

    let isShowQuickGuide = localStorage.getItem('isShowQuickGuide') || 'true';
    if (isShowQuickGuide === 'true') {
      FJUtil.ealog('timeline_welcome panel show');
      setIsShowQuickGuideModal(true);
    }

    updateLimits();
    updateLevel();
    checkLevel();
    dealCloudZone();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.timeLineHeightRadio !== this.props.timeLineHeightRadio) {
      this._adaptScreen();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => {
      this._adaptScreen();
    });
  }

  /**
   * @description 自适应屏幕一半
   * @private
   */
  _adaptScreen = () => {
    let clientHeight = document.body.clientHeight - 60;
    this.setState({
      height: Math.floor(clientHeight * this.props.timeLineHeightRadio),
    });
  };

  /**
   * @description 当某被拖动的对象在另一对象容器范围内拖动时触发此事件
   * @param e
   * @private
   */
  _onDragOver = (e) => {
    window.RC.isFJDragging = true;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = window.RC.hasModal || window.RC.shownExportView ? 'none' : 'drop';
    this.props.changeDragMode(FJActionConstant.DRAG_FILE_MODE_RESOURCE);
  };

  /**
   * @description 当被鼠标拖动的对象离开其容器范围内时触发此事件
   * @param e
   * @private
   */
  _onDragLeave = (e) => {
    window.RC.isFJDragging = false;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    e.preventDefault();
    e.stopPropagation();
    this.timer = setTimeout(() => {
      if (!window.RC.isFJDragging) {
        this.props.changeDragMode(null);
      }
    }, 100);
  };

  /**
   * @description 在一个拖动过程中，释放鼠标键时触发此事件
   * @param e
   * @private
   */
  _onDrop = (e) => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    e.preventDefault();
    e.stopPropagation();
    this.props.changeDragMode(null);
    window.RC.isFJDragging = false;
  };

  render() {
    let {height} = this.state;
    let {endCropMode} = this.props;
    let topHeight = document.body.clientHeight - 60 - height;
    return (
      <div className={styles.container}
           onDragOver={this._onDragOver}
           onDragLeave={this._onDragLeave}
           onMouseDown={endCropMode}
           onDrop={this._onDrop}
      >
        <div className={styles.left_menu}>
          <FJMenuContainer />
        </div>
        <FJHeaderContainer/>
        <div className={styles.main_box} style={{height: topHeight}}>
          <FJResourcesContainer height={topHeight}/>
          <FJPreviewContainer height={topHeight}/>
        </div>
        <FJTimeLineContainer height={height}/>
        <FJExportModalContainer />
        <FJModalContainer/>
        {
          !FJUtil.isSupportBrowser()? <FJBrowserFilter/> : null
        }
      </div>
    );
  }
}

const mapStateTpProps = function (state) {
  return {
    dragFileMode: state.media.dragFileMode,
    timeLineHeightRadio: state.timeline.timeLineHeightRadio
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    changeDragMode: function (data) {
      dispatch(FJMediaAction.changeDragModeAction(data));
    },
    setIsShowQuickGuideModal: function (boolean) {
      dispatch(FJModalAction.setIsShowQuickGuideModalAction(boolean));
    },
    endCropMode: function (e) {
      FJCanvasStore.executeSync(FJCanvasStore.command.APP_CONTENT_MOUSE_DOWN, FJCoreUtil.calcCursorPoint(e));
    },
    updateAllDownloadData: function () {
      dispatch(FJMediaAction.updateAllDownloadDataAction());
    },
    levelChangedCallback: function (data) {
      dispatch(FJPaymentAction.levelChangedCallbackAction(data))
    },
    updateLimits: function () {
      dispatch(FJPaymentAction.updateLimitsAction())
    },
    updateLevel: function () {
      dispatch(FJPaymentAction.updateLevelAction())
    },
    checkLevel: function () {
      dispatch(FJPaymentAction.checkLevelAction())
    },
    dealCloudZone: function () {
      dispatch(FJCloudAction.dealCloudZoneAction)
    },
    showStorageFulled: function () {
      dispatch(FJMediaAction.showStorageFulledAction())
    }
  }
};

export default connect(mapStateTpProps, mapDispatchToProps)(AppContent);
